import HundredBricksAPIError from '../../../../HundredBricksAPIError';
class MonthlySummaryError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('MonthlySummaryError', ...args);
    }
}
export default MonthlySummaryError;
